import { useLoggedInUser } from 'api'

export default function useIsServiceMutationDisabled(userGroupId) {
  const {user} = useLoggedInUser()
  const isServiceMutationDisabled = !user.userGroupRoles.find(ugr => ugr.memberType !== 'VIEWER' && ugr.userGroup._id === userGroupId)
  // return { isServiceMutationDisabled }
  return false
}